
export interface IReplicaImagem {
    id?: number;
    replica?: ReplicaImagem | null;
    imagemContentType?: string | null;
    imagem?: string | null;
    descricao?: string | null;
  }

  export class ReplicaImagem implements IReplicaImagem {
    constructor(
      public id?: number,
      public replica?: ReplicaImagem | null,
      public imagemContentType?: string | null,
      public imagem?: string | null,
      public descricao?: string | null,
    ) {}
  }

  export function getReplicaImagemIdentifier(replicaImagem: IReplicaImagem): number | undefined {
    return replicaImagem.id;
  }
